<ui-header [full]="true">
    @if (showPicker) {
        <ui-pr-env-picker />
    }
</ui-header>
